import React, { useContext, useEffect, useMemo, useRef } from 'react';
import {
  Button,
  Modal,
  Icon,
  Loader,
  Dimmer,
  Form,
  Grid,
  Popup,
} from 'semantic-ui-react';
import InputField from '../../../commonComponents/Input';
import { displayMasterItem } from '../../../CBSA_App/components/entrySummaryForms/util';
import {
  search_DIS_DOC_CODES_apx,
  search_GET_DIF_DOC_TYPE_apx,
} from '../../../apiCalls/MainFormRequests';
import _, { debounce } from 'lodash';
import DateInputField from '../../../commonComponents/DateField';
import DropDown from '../../../CBP_App/formComponents/dropDown';
import './dc.css';
import DifWarnings from './DifWarnings';
import { functionCodes, uomList } from './DifHelper';
import { tbodyFunction } from './tbodyFunction';
import DifContext from './DifContext';
import { convertDateToUTCEpoch1 } from '../../../CBSA_App/components/entrySummaryForms/invoiceSections/helper';
import { displayMasterItem2 } from '../../../CBSA_App/components/entrySummaryForms/util/index';
import { useSelector } from 'react-redux';
import DropDownFilteringDif from '../../../CBSA_App/components/formComponents/dropDownFileringDif';
import { convertDate } from '../../../CBSA_App/components/entrySummaryForms/invoiceSections/merchandiseSections/PgaComp/helper';
import ZoomSlider from '../../MainForm/ZoomSlider';
import CommonModal from '../../Modals/CommonModal';
import DisHistoryDetails from './DisHistoryDetails/index';
export const DifModal = () => {
  const {
    shipmentCountry,
    nameofdoc,
    numberofpagesbydoctype,
    doclistcombined,
    state,
    commentBox,
    nextprevbuttons,
    requestSuccess,
    setState,
    disDocumentTypeSearchForCodes,
    toggleDocumentType,
    selectdocumentType,
    props,
    getFileLengthFlag,
    uploadFilesforDoc,
    addMoreDocs,
    donewithdocumentType,
    isDisabled,
    saveDIFValue,
    checkBoxStyle,
    submit_difff,
    submit_dis_requesttt,
    create_pdff,
    subType,
    engineBolRecords,
    selectedKxShipmentId,
    reloadDocs,
    lpcoIssueDate,
  } = useContext(DifContext);

  const usStateCode = useSelector((state) => state.DropDownValues?.usStateCode);
   const viewHistoryRef = useRef(null)
  let countryOfOriginDropdown = useSelector(
    (state) => state?.DropDownValues?.countryOfOrigin
  );
  if (!!usStateCode) {
    countryOfOriginDropdown = [...countryOfOriginDropdown, ...usStateCode];
  }
  const countryOriginfiltered = countryOfOriginDropdown?.filter(
    (dropdown) => dropdown.value !== 'US'
  );
  const countryOriginDropdown = useMemo(() => countryOriginfiltered, []);

  const customFunction = (options, query) => {
    const queries = query.charAt(0).toUpperCase() + query.slice(1);
    let result = countryOriginfiltered.filter(
      (opt) => opt.value === query.toUpperCase() || opt.text === queries
    );
    return result;
  };

  const canSelectIndividualPages = shipmentCountry == 'US' ||shipmentCountry === "CA" ;

  const getCurrentDate = () => {
    const date = new Date();
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();
    let currentDate = `${year}-${month}-${day}`;
    const result = new Date(currentDate);
    let finalResult = convertDateToUTCEpoch1(new Date(result));
    return finalResult;
  };

  useEffect(() => {
    search_GET_DIF_DOC_TYPE_apx('', props.pgaType || '', subType || '').then(
      (response) => {
        let descriptionscleaned = [];
        for (let onethingy of response.data.eventMessage.docTypeForCode || []) {
          descriptionscleaned.push({
            key: onethingy.documentCode,
            id: onethingy.documentCode,
            value: onethingy.documentType,
            description: onethingy.documentType,
          });
        }
        setState({
          documentTypes: descriptionscleaned,
        });
      }
    );
  }, [props.pgaType, subType]);

  let dontUseTheseDocIds = state.dontUseTheseDocIds || {};
  let hasTheseDocsForThisType = (docType, showUnusedDocs) => {
    let allDocsForThisType = ((state.doclistttt||{})[selectedKxShipmentId]||[]).filter((a) => {
      if (docType != 'use__id') {
        if (!docType) {
          //If no doctype param, select all documents within selected document types
          return (state.selectedDocuments_lo || []).includes(a.documentType);
        }
        return (
          //If doctype param, select all documents within a specific document type
          a.documentType == docType
        );
      } else {
        //Show just a specifici docid
        return a.docid == state.selectedDocId_p;
      }
    });
    if (showUnusedDocs) return allDocsForThisType; //Don't filter by the ignore document feature
    return allDocsForThisType.filter((a) => !dontUseTheseDocIds[a.docid]); //Filter by the ignore document feature
  };

  let toggleThisDocType = (onedoccname, textttt) => {
    return (
      <div
        className='cancel-button blue'
        style={{ display: 'inline-block' }}
        onClick={() => {
          toggleDocumentType(onedoccname);
        }}
      >
        <input
          type='checkbox'
          checked={
            state.selectedDocuments_lo.indexOf(onedoccname) >= 0
              ? 'checked'
              : false
          }
        />
        &nbsp; {textttt}
      </div>
    );
  };
  return (
    <Modal className={'documentimageserviceschooser'} open={true}>
      {shipmentCountry != 'CA' && (
        <div className='topBarbn'>
          <div
            style={{
              fontWeight: state.currentpage == 'initial' ? 'bold' : 'normal',
            }}
          >
            1. Create PDF
          </div>
          <div className='horizontalline'>
            <div></div>
          </div>
          <div
            style={{
              fontWeight: state.currentpage == 'pdfpage' ? 'bold' : 'normal',
            }}
          >
            2.Review and submit PDF
          </div>
          <div className='horizontalline'>
            <div></div>
          </div>
          <div
            style={{
              fontWeight: state.currentpage == 'final' ? 'bold' : 'normal',
            }}
          >
            3.Complete
          </div>
        </div>
      )}
      {/* START Documents required for */}
      {shipmentCountry != 'CA' && (
        <div className='documentsRequiredHeader'>
          <div style={{ display: 'flex',gap: '10px' }}>
            <div style={{ flex: 1 }}>
          Documents required for &nbsp;
          {!state.isChoosingaNewDoctype ? (
            <>
              {nameofdoc}{' '}
              {state.currentpage == 'initial' && !state.creatingpdf && (
                <small
                  style={{ color: 'blue', cursor: 'pointer', whiteSpace: 'nowrap' }}
                  onClick={() => {
                    setState({ isChoosingaNewDoctype: true });
                  }}
                >
                  Change Document Type
                </small>
              )}
            </>
            
          ) :null}
          </div>
           <div className='rightButtons'>
            <Button
              color='teal'
              floated='right'
              // disabled={isLoading}
              onClick={() => {
                if (viewHistoryRef?.current) {
                  viewHistoryRef.current.open();
                }
              }}
        >
          View History
        </Button>

            <CommonModal
              ref={viewHistoryRef}
              header="Documents History"
              className='fileUploadHistoryModal'
              closeIcon={false}
               content={<DisHistoryDetails onClose={viewHistoryRef.current?.close} />}
              actions={
                <Button  color='blue' onClick={() => viewHistoryRef.current?.close()}>Close</Button>
              }
            />
        </div>
          </div>
           
           {state.isChoosingaNewDoctype? <div>
              {/* START DOCTYPE DROPDOWN */}
              Search document/agency types (eg: 'CBP')
              <DropDown
                id={'epu'}
                className='field-bg dropdown100  decl-part'
                labelClass='text-none'
                isLabel={true}
                data={state.nameofdocguesses}
                onChange={(value) => {
                  setState({
                    docCodeName: value,
                    nameofdocarray: state.nameofdocguesses,
                    isChoosingaNewDoctype: false,
                  });
                }}
                onClick={(value) => {}}
                onKeyPress={(value) => {
                  disDocumentTypeSearchForCodes(value);
                }}
              />
              {/* END DOCTYPE DROPDOWN */}
            </div>:null}
        </div>
      )}
      {/* END Documents required for */}
      {(state.headers_ll || []).map((obob, iiil) => {
        {
          return (
            obob.field == 'Shipment Doc Status' && (
              <h3 key={obob.fieldmessage + 'fooabc123'}>{obob.fieldmessage}</h3>
            )
          );
        }
      })}
      As per customs guidelines you are required to submit the following list of
      documents.
      <br />
      <br />
      {/* START INITIAL */}
      {state.currentpage == 'initial' && !state.creatingpdf && (<>
      
            

            
            {(engineBolRecords||[]).map((oneEngine, xiii) => {
                    // if((oneEngine.intakeShipmentId+"").indexOf("KN")==0)return;
                    return(
                    <a
                      href="#"
                      key={xiii+"xxx"+oneEngine.intakeShipmentId}
                      style={{ width: "16%", float: "left", zIndex: -10 + 5 }}
                      className={
                        " accordian-section xyTabStyle tab-content " +
                        (selectedKxShipmentId==oneEngine.intakeShipmentId
                          ? " activeTabm "
                          : " ") 
                      }
                      onClick={() => {
                        setState({selectedKxShipmentId:oneEngine.intakeShipmentId});
                      }}
                      onKeyPress={(e) => {
                        setState({selectedKxShipmentId:oneEngine.intakeShipmentId});
                      }}
                    >
                      <div className="cornerimg">
                        <div></div>
                      </div>
                      <div className="title">
                        {oneEngine.intakeShipmentId}
                      </div>
                    </a>
                  )})}

        <table>
          <tbody>
            <tr>
              <td style={{ verticalAlign: 'top', width: '55%' }}>
                <div
                  className={`${shipmentCountry} disDocumentPickerContainer`}
                >
                  <table className='disDocumentPicker'>
                    <thead>
                      <tr>
                        <td>#</td>
                        <td style={{ paddingLeft: '9px' }}>✓</td>
                        <td>
                          Select documents for{' '}
                          {state.docCodeName && state.docCodeName.length > 3
                            ? state.docCodeName
                            : ''}{' '}
                          submission
                        </td>
                        <td>Number of Pages</td>
                        {shipmentCountry == 'CA' && <td>Form</td>}
                        {state.documentStatusList_ka.length > 0 && (
                          <td>Status</td>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {tbodyFunction(
                        false,
                        numberofpagesbydoctype,
                        state,
                        state.docTypes_zb,
                        (val) => toggleDocumentType(val),
                        (a, b) => selectdocumentType(a, b),
                        shipmentCountry,
                        hasTheseDocsForThisType,
                        canSelectIndividualPages,
                        state.documentTypes,
                        selectedKxShipmentId
                      )}
                      {!!state.selectedDocuments_lo?.length && (
                        <tr>
                          <td colSpan='5'>
                            <b
                              style={{
                                display: 'inline-block',
                                padding: '5px',
                                paddingBottom: '0px',
                              }}
                            >
                              Selected Documents:
                            </b>
                          </td>
                        </tr>
                      )}
                      {tbodyFunction(
                        true,
                        numberofpagesbydoctype,
                        state,
                        state.docTypes_zb,
                        (val) => toggleDocumentType(val),
                        (a, b) => selectdocumentType(a, b),
                        shipmentCountry,
                        hasTheseDocsForThisType,
                        canSelectIndividualPages,
                        state.documentTypes,
                        selectedKxShipmentId
                      )}
                    </tbody>
                  </table>
                </div>
                <table className='disDocumentPicker'>
                  <tbody>
                    {state.doclist_lg.map((onenewdocl, ibii) => {
                      let { uploadDocStatuses } = state;
                      let currentCount = '';
                      for (let key of Object.keys(uploadDocStatuses)) {
                        let mycurid = _.get(
                          uploadDocStatuses[key],
                          'documentobject.id',
                          0
                        );
                        if (mycurid == onenewdocl.id) {
                          currentCount = _.get(
                            uploadDocStatuses[key],
                            'counterx',
                            ''
                          );
                        }
                      }
                      if (onenewdocl.uploadStatus == 'SUCCESS') {
                        return <></>;
                      }
                      return (
                        <tr key={onenewdocl.id + 'foonnnmagic'}>
                          {onenewdocl.isDone ? (
                            <td>{onenewdocl.uploadStatus}</td>
                          ) : (
                            <>
                              {!onenewdocl.isLoading && (
                                <td>
                                  {/* start onenewdocl.isLoading td */}

                                  <div className='dropdowncontainerthingy'>
                                    <DropDown
                                      id={'epu'}
                                      className='field-bg dropdown100  decl-part'
                                      labelClass='text-none'
                                      isLabel={true}
                                      data={(
                                        onenewdocl.nameofdocguesses || []
                                      ).sort((a, b) =>
                                        a.key.localeCompare(b.key, undefined, {
                                          numeric: true,
                                          sensitivity: 'base',
                                        })
                                      )}
                                      label="Type to search doctypes (ie 'CBP')"
                                      onKeyPress={(value) => {
                                        onenewdocl.newdoctypetouse = value;
                                        let functionToSearchWith;
                                        if (shipmentCountry == 'CA') {
                                          //CA!!
                                          search_GET_DIF_DOC_TYPE_apx(
                                            value || '',
                                            props.pgaType || '',
                                            subType || ''
                                          ).then((response) => {
                                            let descriptionscleaned = [];
                                            for (let onethingy of response.data
                                              .eventMessage.docTypeForCode ||
                                              []) {
                                              descriptionscleaned.push({
                                                key: onethingy.documentCode,
                                                id: onethingy.documentCode,
                                                value: onethingy.documentType,
                                                description:
                                                  onethingy.documentType,
                                              });
                                            }
                                            onenewdocl.nameofdocguesses =
                                              descriptionscleaned;

                                            if (
                                              onenewdocl.newdoctypetouse ==
                                              value
                                            ) {
                                              setState({
                                                doclistcombined:
                                                  doclistcombined,
                                              });
                                            }
                                            setState({
                                              doclist_lg: state.doclist_lg,
                                            });
                                          });
                                        } else {
                                          //USA!
                                          search_DIS_DOC_CODES_apx(
                                            value || ''
                                          ).then((response) => {
                                            let descriptionscleaned = [];
                                            for (let onethingy of response.data
                                              .eventMessage.docCodeToDesc ||
                                              []) {
                                              descriptionscleaned.push({
                                                key: onethingy.key,
                                                id: onethingy.key,
                                                value: onethingy.value,
                                                description: onethingy.value,
                                              });
                                            }
                                            onenewdocl.nameofdocguesses =
                                              descriptionscleaned;

                                            if (
                                              onenewdocl.newdoctypetouse ==
                                              value
                                            ) {
                                              setState({
                                                doclistcombined:
                                                  doclistcombined,
                                              });
                                            }
                                            setState({
                                              doclist_lg: state.doclist_lg,
                                            });
                                          });
                                        }
                                      }}
                                      onChange={(value) => {
                                        onenewdocl.doctype =
                                          onenewdocl.nameofdocguesses.find(
                                            (a) => a.key == value
                                          );
                                        setState({
                                          doclist_lg: state.doclist_lg,
                                        });
                                      }}
                                      onClick={(value) => {}}
                                    />
                                  </div>

                                  <button
                                    onClick={() => {
                                      onenewdocl.isDone = true;

                                      setState({
                                        doclist_lg: state.doclist_lg,
                                      });
                                    }}
                                  >
                                    Cancel...
                                  </button>
                                  <input
                                    type='file'
                                    onChange={(e) => {
                                      if (!e.target || !e.target.files) return;

                                      // getFileLengthFlag(
                                      //   e.target.files,
                                      //   shipmentCountry
                                      // );

                                      onenewdocl.files = e.target.files;
                                      setState({
                                        doclist_lg: state.doclist_lg,
                                      });
                                    }}
                                  />
                                </td>
                              )}
                              {/* end onenewdocl.isLoading td */}
                              <td style={{ height: '60px' }}>
                                {!onenewdocl.isLoading ? (
                                  <>
                                    <Button
                                      onClick={() => {
                                        if (
                                          !onenewdocl.files ||
                                          !onenewdocl.doctype ||
                                          onenewdocl.isLoading
                                        )
                                          return;

                                        onenewdocl.isLoading = true;
                                        setState({
                                          doclist_lg: state.doclist_lg,
                                        });
                                        uploadFilesforDoc(onenewdocl);
                                      }}
                                      disabled={
                                        !onenewdocl.files ||
                                        !onenewdocl.doctype ||
                                        onenewdocl.isLoading ||
                                        !new RegExp(
                                          /^[a-zA-Z_0-9\+\-\.]+$/
                                        ).test(
                                          _.get(onenewdocl, 'files[0].name', '')
                                        )
                                      }
                                      basic
                                      color='blue'
                                      style={{ width: '100%' }}
                                      circular
                                      compact
                                    >
                                      {!onenewdocl.files
                                        ? 'Choose a file'
                                        : !onenewdocl.doctype
                                        ? 'Choose a doctype'
                                        : !new RegExp(
                                            /^[a-zA-Z_0-9\+\-\.]+$/
                                          ).test(
                                            _.get(
                                              onenewdocl,
                                              'files[0].name',
                                              ''
                                            )
                                          )
                                        ? 'Filename must be alphanumeric - + . _'
                                        : `Upload ${_.get(
                                            onenewdocl,
                                            'files[0].name',
                                            ''
                                          )} as ${onenewdocl.doctype.key}`}
                                    </Button>
                                  </>
                                ) : (
                                  <div
                                    style={{
                                      height: '2rem',
                                      fontSize: '.7rem',
                                      position: 'relative',
                                      minWidth: '300px',
                                    }}
                                  >
                                    <Dimmer
                                      active
                                      inverted
                                      className='bigDimmerContent'
                                    >
                                      {!onenewdocl.uploadStatus ||
                                      onenewdocl.uploadStatus ==
                                        'IN_PROGRESS' ? (
                                        <Loader
                                          inverted
                                          content={`Saving ${
                                            onenewdocl.files &&
                                            onenewdocl.files[0].name
                                          } as ${
                                            onenewdocl.doctype &&
                                            onenewdocl.doctype.key
                                          }, just a moment... ${
                                            onenewdocl.uploadStatus
                                              ? onenewdocl.uploadStatus
                                                  .replaceAll('_', ' ')
                                                  .toLowerCase() + '...'
                                              : ''
                                          }
                                                  
                                                ${currentCount}`}
                                        />
                                      ) : (
                                        <>
                                          {onenewdocl.uploadStatus
                                            ? onenewdocl.uploadStatus
                                                .replaceAll('_', '')
                                                .toLowerCase() + '...'
                                            : ''}
                                        </>
                                      )}
                                    </Dimmer>
                                  </div>
                                )}
                              </td>
                            </>
                          )}{' '}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>

                <br />
                <br />
                <div className={'sticky-btn-container'}>
                  <a
                    onClick={() => addMoreDocs()}
                    style={{ cursor: 'pointer' }}
                  >
                    Add additional Documents{' '}
                    {state.docCodeName && state.docCodeName.length > 3
                      ? ' to ' + state.docCodeName
                      : ''}
                  </a>
                </div>
                {shipmentCountry == 'US' && (
                  <>
                    <br />
                    <br />
                    <table>
                      <tbody>
                        <tr>
                          <td style={{ width: '150px' }}>DIS Comment:</td>
                          <td>{commentBox}</td>
                        </tr>
                      </tbody>
                    </table>
                  </>
                )}

                {shipmentCountry == 'CA' &&
                  state.disvars[state.selectedDocType] && (
                    <>
                      {!state.selectedDocuments_lo.includes(
                        state.selectedDocType
                      ) ? (
                        <>
                          <br />
                          <br />
                          Select {state.selectedDocType} before modifying it
                        </>
                      ) : (
                        <>
                          <div
                            className={
                              'dashedContainer' +
                              state.selectedDocuments_lo.includes(
                                state.selectedDocType
                              )
                                ? ''
                                : ' disabled '
                            }
                          >
                            <h2>{state.selectedDocType} DIF Form</h2>

                            {/* <Grid.Row>
                              <Grid.Column width='12'>
                                <div style={{ width: '100%' }}>
                                  <button
                                    disabled={isDisabled()}
                                    onClick={() => {
                                      donewithdocumentType(
                                        state.selectedDocType
                                      );
                                    }}
                                  >
                                    Form is checked, set {state.selectedDocType}{' '}
                                    to ready
                                  </button>
                                </div>
                              </Grid.Column>
                              <Grid.Column
                                width='4'
                                style={{ marginLeft: '20%' }}
                              >
                                <DropDown
                                  id={
                                    'apjghhavs-proc123p3h2132' +
                                    state.selectedDocType
                                  }
                                  className='field-bg dropdown100'
                                  // labelClass='text-none'
                                  label='DIF Function'
                                  isLabel={true}
                                  data={functionCodes}
                                  text={
                                    state.disvars[state.selectedDocType]
                                      .functionCode
                                      ? functionCodes.find(
                                          (i) =>
                                            i.id ==
                                            state.disvars[state.selectedDocType]
                                              .functionCode
                                        )?.description
                                      : 'DIF Function'
                                  }
                                  onChange={(value) => {
                                    saveDIFValue('functionCode', value);
                                  }}
                                />
                              </Grid.Column>
                            </Grid.Row> */}
                            <br />
                            <Form
                              id={'disdif-formf1' + state.selectedDocType}
                              className={'disdif-formf1 heightshrunkform'}
                              key={state.selectedDocType + 'adwaddwa1'}
                            >
                              <div className='merged-column sixteen wide'>
                                {!!state.showForm ? (
                                  <>
                                    {shipmentCountry == 'CA' && (
                                      <DropDown
                                        width={14}
                                        className='doc-img-chsr field-bg'
                                        error={'Document type is mandatory'}
                                        labelClass='text-none'
                                        isLabel={true}
                                        data={state.documentTypes}
                                        text={
                                          state.disvars[state.selectedDocType]
                                            .lpcoImageTypeCode
                                            ? `${
                                                state.disvars[
                                                  state.selectedDocType
                                                ].lpcoImageTypeCode
                                              } - Document Type`
                                            : "Type to search doc types (E.g. '40')"
                                        }
                                        onChange={(value) => {
                                          saveDIFValue(
                                            'lpcoImageTypeCode',
                                            value
                                          );
                                        }}
                                        onKeyPress={(value) => {
                                          if (shipmentCountry == 'CA') {
                                            search_GET_DIF_DOC_TYPE_apx(
                                              value || '',
                                              props.pgaType || '',
                                              subType || ''
                                            ).then((response) => {
                                              let descriptionscleaned = [];
                                              for (let onethingy of response
                                                .data.eventMessage
                                                .docTypeForCode || []) {
                                                descriptionscleaned.push({
                                                  key: onethingy.documentCode,
                                                  id: onethingy.documentCode,
                                                  value: onethingy.documentType,
                                                  description:
                                                    onethingy.documentType,
                                                });
                                              }
                                              setState({
                                                documentTypes:
                                                  descriptionscleaned,
                                              });
                                            });
                                            return;
                                          }
                                          search_GET_DIF_DOC_TYPE_apx(
                                            value || ''
                                          ).then((response) => {
                                            let descriptionscleaned = [];
                                            for (let onethingy of response.data
                                              .eventMessage.docTypeForCode ||
                                              []) {
                                              descriptionscleaned.push({
                                                key: onethingy.documentCode,
                                                id: onethingy.documentCode,
                                                value: onethingy.documentType,
                                                description:
                                                  onethingy.documentType,
                                              });
                                            }
                                            setState({
                                              documentTypes:
                                                descriptionscleaned,
                                            });
                                          });
                                        }}
                                      />
                                    )}

                                    <Form.Group className='merged-row '>
                                      {shipmentCountry !== 'CA' && (
                                        <InputField
                                          id={
                                            'apgfhhavs-proc12332132' +
                                            state.selectedDocType
                                          }
                                          label={'Document Type'}
                                          className={'field-bg'}
                                          width={5}
                                          value={
                                            state.disvars[state.selectedDocType]
                                              .lpcoImageTypeCode
                                          }
                                          onChange={(value) =>
                                            saveDIFValue(
                                              'lpcoImageTypeCode',
                                              value
                                            )
                                          }
                                        />
                                      )}
                                      <InputField
                                        id={
                                          'aphjhgavs-proc12332132' +
                                          state.selectedDocType
                                        }
                                        errors={
                                          state.disvars[state.selectedDocType]
                                            ?.lpcoReferenceNumber
                                            ? null
                                            : [
                                                'Document Reference Number is mandatory',
                                              ]
                                        }
                                        className={'field-bg'}
                                        label={'Document Reference Number'}
                                        width={8}
                                        value={
                                          state.disvars[state.selectedDocType]
                                            .lpcoReferenceNumber
                                        }
                                        onChange={(value) =>
                                          saveDIFValue(
                                            'lpcoReferenceNumber',
                                            value
                                          )
                                        }
                                      />
                                      <InputField
                                        id={
                                          'apkjhhavs-proc12332132' +
                                          state.selectedDocType
                                        }
                                        errors={
                                          state.disvars[state.selectedDocType]
                                            ?.identifier
                                            ? null
                                            : ['URN is mandatory']
                                        }
                                        label={'URN'}
                                        width={8}
                                        value={
                                          state.disvars[state.selectedDocType]
                                            ?.identifier || ''
                                        }
                                        onChange={(value) => {
                                          if (shipmentCountry !== 'CA') {
                                            saveDIFValue('identifier', value);
                                          }
                                        }}
                                      />
                                    </Form.Group>

                                    <Form.Group className='merged-row sixteen wide leftBorder'>
                                      {props?.pgaType == 'GAC' ? (
                                        <InputField
                                          className='spacing-fields leftBorderZero'
                                          label={'LPCO Issue Date'}
                                          width={5}
                                          disabled
                                          date={true}
                                          value={convertDate(lpcoIssueDate)}
                                        />
                                      ) : (
                                        <DateInputField
                                          id={
                                            'aphavs-proc12332132455' +
                                            state.selectedDocType
                                          }
                                          label={'LPCO Issue Date'}
                                          width={5}
                                          date={true}
                                          value={
                                            state.disvars[state.selectedDocType]
                                              .issueDate
                                          }
                                          onChange={(value) =>
                                            saveDIFValue('issueDate', value)
                                          }
                                        />
                                      )}

                                      <DateInputField
                                        component={
                                          <Popup
                                            content='If no effective date, checking box will default to Submission Date'
                                            style={{ zIndex: 9999999 }}
                                            trigger={
                                              <input
                                                style={checkBoxStyle}
                                                type='checkbox'
                                                checked={
                                                  state.disvars[
                                                    state.selectedDocType
                                                  ]?.lpcoImageEffectiveDate !=
                                                  getCurrentDate()
                                                    ? false
                                                    : true
                                                }
                                                onChange={() => {
                                                  if (
                                                    state.disvars[
                                                      state.selectedDocType
                                                    ]?.lpcoImageEffectiveDate !=
                                                    getCurrentDate()
                                                  ) {
                                                    saveDIFValue(
                                                      'lpcoImageEffectiveDate',
                                                      getCurrentDate()
                                                    );
                                                  } else {
                                                    saveDIFValue(
                                                      'lpcoImageEffectiveDate',
                                                      ''
                                                    );
                                                  }
                                                }}
                                              />
                                            }
                                          />
                                        }
                                        id={
                                          'aphavs-pro123c12332132' +
                                          state.selectedDocType
                                        }
                                        errors={
                                          state.disvars[state.selectedDocType]
                                            ?.lpcoImageEffectiveDate
                                            ? null
                                            : [
                                                'LPCO Image Effective Date is mandatory',
                                              ]
                                        }
                                        label={'LPCO Image Effective Date'}
                                        width={6}
                                        date={true}
                                        value={
                                          state.disvars[state.selectedDocType]
                                            .lpcoImageEffectiveDate
                                        }
                                        onChange={(value) => {
                                          saveDIFValue(
                                            'lpcoImageEffectiveDate',
                                            value
                                          );
                                        }}
                                        className=''
                                      />
                                      <DateInputField
                                        component={
                                          <Popup
                                            content='If no expiry date, checking box will default to CBSA-specified Future Date'
                                            style={{ zIndex: 9999999 }}
                                            trigger={
                                              <input
                                                style={checkBoxStyle}
                                                type='checkbox'
                                                checked={
                                                  state.disvars[
                                                    state.selectedDocType
                                                  ]?.lpcoImageExpiryDate !=
                                                  new Date(
                                                    '9999-12-31'
                                                  ).getTime()
                                                    ? false
                                                    : true
                                                }
                                                onChange={() => {
                                                  if (
                                                    state.disvars[
                                                      state.selectedDocType
                                                    ]?.lpcoImageExpiryDate !=
                                                    new Date(
                                                      '9999-12-31'
                                                    ).getTime()
                                                  ) {
                                                    saveDIFValue(
                                                      'lpcoImageExpiryDate',
                                                      new Date(
                                                        '9999-12-31'
                                                      ).getTime()
                                                    );
                                                  } else {
                                                    saveDIFValue(
                                                      'lpcoImageExpiryDate',
                                                      ''
                                                    );
                                                  }
                                                }}
                                              />
                                            }
                                          />
                                        }
                                        id={
                                          'aphavs-proc123321132' +
                                          state.selectedDocType
                                        }
                                        errors={
                                          state.disvars[state.selectedDocType]
                                            .lpcoImageExpiryDate
                                            ? null
                                            : [
                                                'LPCO Image Expiry Date is mandatory',
                                              ]
                                        }
                                        label={'LPCO Image Expiry Date'}
                                        width={5}
                                        date={true}
                                        value={
                                          state.disvars[state.selectedDocType]
                                            .lpcoImageExpiryDate
                                        }
                                        onChange={(value) =>
                                          saveDIFValue(
                                            'lpcoImageExpiryDate',
                                            value
                                          )
                                        }
                                        className=''
                                      />
                                    </Form.Group>

                                    <Form.Group className='merged-row'>
                                      <DropDownFilteringDif
                                        style={{ borderRadius: '0px' }}
                                        id={
                                          'aphakjhvs-proc123j32132' +
                                          state.selectedDocType
                                        }
                                        labelTitle={'COUNTRY OF ORIGIN'}
                                        className='field-bg dropdown100 cbsa-country-of-origin'
                                        labelClass='text-none'
                                        width={5}
                                        label={'Country of Origin'}
                                        search={customFunction}
                                        // errors={}
                                        text={displayMasterItem2(
                                          state.disvars[state.selectedDocType]
                                            .countryOfOrigin,
                                          countryOriginDropdown
                                        )}
                                        data={countryOriginDropdown}
                                        value={
                                          state.disvars[state.selectedDocType]
                                            .countryOfOrigin
                                        }
                                        onChange={(value) =>
                                          saveDIFValue('countryOfOrigin', value)
                                        }
                                      />
                                      <DropDownFilteringDif
                                        style={{
                                          borderRadius: '0px',
                                          borderLeft: '0px !important',
                                        }}
                                        id={
                                          'aphakjhvs-proc123j32132' +
                                          state.selectedDocType
                                        }
                                        labelTitle={'Place of Authentication'}
                                        className='field-bg dropdown100 cbsa-country-of-origin'
                                        labelClass='text-none'
                                        width={6}
                                        label={'Place of Authentication'}
                                        search={customFunction}
                                        // errors={}
                                        text={displayMasterItem2(
                                          state.disvars[state.selectedDocType]
                                            .placeOfauthentication,
                                          countryOriginDropdown
                                        )}
                                        data={countryOriginDropdown}
                                        value={
                                          state.disvars[state.selectedDocType]
                                            .placeOfauthentication
                                        }
                                        onChange={(value) =>
                                          saveDIFValue(
                                            'placeOfauthentication',
                                            value
                                          )
                                        }
                                      />

                                      <DropDownFilteringDif
                                        style={{
                                          borderRadius: '0px',
                                          borderLeft: '0px !important',
                                        }}
                                        id={
                                          'aphakjhvs-proc123j32132' +
                                          state.selectedDocType
                                        }
                                        labelTitle={'Place of issue'}
                                        className='field-bg dropdown100 cbsa-country-of-origin'
                                        labelClass='text-none'
                                        width={5}
                                        label={'Place of issue'}
                                        search={customFunction}
                                        // errors={}
                                        text={displayMasterItem2(
                                          state.disvars[state.selectedDocType]
                                            .placeOfIssue,
                                          countryOriginDropdown
                                        )}
                                        data={countryOriginDropdown}
                                        value={
                                          state.disvars[state.selectedDocType]
                                            .placeOfIssue
                                        }
                                        onChange={(value) =>
                                          saveDIFValue('placeOfIssue', value)
                                        }
                                      />
                                    </Form.Group>
                                  </>
                                ) : null}
                              </div>
                            </Form>
                            <Form
                              id={'disdif-formf' + state.selectedDocType}
                              className={'disdif-formf heightshrunkform'}
                              key={state.selectedDocType + 'adwaddwa'}
                            >
                              {[
                                {
                                  id: 'authorizedParty',
                                  name: 'Authorized Party',
                                },
                                {
                                  id: 'applicantParty',
                                  name: 'Applicant Party',
                                },
                              ].map((strri, iil) => {
                                let currobj;
                                if (
                                  !state.disvars ||
                                  !state.disvars[state.selectedDocType] ||
                                  !state.disvars[state.selectedDocType][
                                    strri.id
                                  ]
                                )
                                  currobj = {};
                                else
                                  currobj =
                                    state.disvars[state.selectedDocType][
                                      strri.id
                                    ];
                                return (
                                  <React.Fragment
                                    key={strri['id'] + 'bvnnbvnbvb'}
                                  >
                                    <h6>{strri.name}</h6>
                                    <div className='merged-column noborders'>
                                      <Form.Group className='merged-row'>
                                        <InputField
                                          id={
                                            'apjghhfavs-proc12332132' +
                                            state.selectedDocType +
                                            strri.id
                                          }
                                          width={16}
                                          label={strri.name} //Only for this one!
                                          value={
                                            strri.id == 'authorizedParty'
                                              ? currobj.authPartyName
                                              : currobj.applicantPartyName
                                          }
                                          onChange={(value) => {
                                            if (strri.id == 'authorizedParty')
                                              saveDIFValue(strri.id, {
                                                authPartyName: value,
                                              });
                                            else
                                              saveDIFValue(strri.id, {
                                                applicantPartyName: value,
                                              });
                                          }}
                                        />
                                      </Form.Group>
                                      <Form.Group className='merged-row'>
                                        <InputField
                                          id={
                                            'apjghhf65avs-proc12332132' +
                                            state.selectedDocType +
                                            strri.id
                                          }
                                          width={16}
                                          className='address-block-input'
                                          label={'Address 1'}
                                          value={currobj.address1}
                                          onChange={(value) => {
                                            saveDIFValue(strri.id, {
                                              address1: value,
                                            });
                                          }}
                                        />
                                        <InputField
                                          id={
                                            'apjgh7896hfavs-proc12332132' +
                                            state.selectedDocType +
                                            strri.id
                                          }
                                          width={16}
                                          className='address-block-input'
                                          label={'Address 2'}
                                          value={currobj.address2}
                                          onChange={(value) => {
                                            saveDIFValue(strri.id, {
                                              address2: value,
                                            });
                                          }}
                                        />
                                      </Form.Group>
                                      <Form.Group className='merged-row notopborders'>
                                        <InputField
                                          id={
                                            'apjghhfa41vs-proc12332132' +
                                            state.selectedDocType +
                                            strri.id
                                          }
                                          width={5}
                                          className='address-block-input'
                                          label={'City'}
                                          value={currobj.city}
                                          onChange={(value) => {
                                            saveDIFValue(strri.id, {
                                              city: value,
                                            });
                                          }}
                                        />
                                        <InputField
                                          id={
                                            'apjghhfavs-proc1y2332132' +
                                            state.selectedDocType +
                                            strri.id
                                          }
                                          width={3}
                                          className='address-block-input'
                                          label={'State'}
                                          value={currobj.state}
                                          onChange={(value) => {
                                            saveDIFValue(strri.id, {
                                              state: value,
                                            });
                                          }}
                                        />
                                        <InputField
                                          id={
                                            'apjghhfavs-proc123392132' +
                                            state.selectedDocType +
                                            strri.id
                                          }
                                          width={3}
                                          className='address-block-input'
                                          label={'Zip'}
                                          value={currobj.zip}
                                          onChange={(value) => {
                                            saveDIFValue(strri.id, {
                                              zip: value,
                                            });
                                          }}
                                        />
                                        <InputField
                                          id={
                                            'apjghhfavs-proc5412332132' +
                                            state.selectedDocType +
                                            strri.id
                                          }
                                          width={5}
                                          className='address-block-input'
                                          label={'Country'}
                                          value={currobj.country}
                                          onChange={(value) => {
                                            saveDIFValue(strri.id, {
                                              country: value,
                                            });
                                          }}
                                        />
                                      </Form.Group>
                                    </div>
                                  </React.Fragment>
                                );
                              })}
                              <br />
                              <div className='merged-column'>
                                <Form.Group className='merged-row'>
                                  <InputField
                                    id={
                                      'aphakiujhvs-proc123j32132' +
                                      state.selectedDocType
                                    }
                                    width={5}
                                    label={'Secondary Reference Info'}
                                    value={
                                      state.disvars[state.selectedDocType]
                                        .secReferenceInfo
                                    }
                                    onChange={(value) =>
                                      saveDIFValue('secReferenceInfo', value)
                                    }
                                  />
                                  <InputField
                                    id={
                                      'aphjkhavs-proc1o23321k32' +
                                      state.selectedDocType
                                    }
                                    width={5}
                                    label={'Alternative Quota QTY.'}
                                    value={
                                      state.disvars[state.selectedDocType]
                                        .altQuotaQty
                                    }
                                    onChange={(value) =>
                                      saveDIFValue('altQuotaQty', value)
                                    }
                                  />

                                  <DropDown
                                    id={
                                      'apjghhavs-proc123p3h2132' +
                                      state.selectedDocType
                                    }
                                    className='field-bg dropdown100'
                                    labelClass='text-none'
                                    isLabel={true}
                                    data={uomList}
                                    text={
                                      displayMasterItem(
                                        state.disvars[state.selectedDocType]
                                          .difUom,
                                        uomList
                                      ) || 'SELECT UOM'
                                    }
                                    onChange={(value) =>
                                      saveDIFValue('difUom', value)
                                    }
                                  />
                                </Form.Group>
                              </div>
                            </Form>
                            <br />
                            <Grid.Row>
                              <Grid.Column
                                width='12'
                                // style={{ marginLeft: '20%' }}
                              >
                                <button
                                  disabled={isDisabled()}
                                  onClick={() => {
                                    donewithdocumentType(state.selectedDocType);
                                  }}
                                >
                                  {state.selectedDocuments_lo.includes(
                                    state.selectedDocType
                                  ) ? (
                                    <>
                                      Form is checked, set{' '}
                                      {state.selectedDocType} to ready
                                    </>
                                  ) : (
                                    <>
                                      Select {state.selectedDocType} with the
                                      above checkbox first!
                                    </>
                                  )}
                                </button>
                              </Grid.Column>
                              <Grid.Column
                                width='4'
                                style={{ marginLeft: '20%' }}
                              >
                                <DropDown
                                  id={
                                    'apjghhavs-proc123p3h2132' +
                                    state.selectedDocType
                                  }
                                  className='field-bg dropdown100'
                                  // labelClass='text-none'
                                  label='DIF Function'
                                  isLabel={true}
                                  data={functionCodes}
                                  text={
                                    state.disvars[state.selectedDocType]
                                      .functionCode
                                      ? functionCodes.find(
                                          (i) =>
                                            i.id ==
                                            state.disvars[state.selectedDocType]
                                              .functionCode
                                        )?.description
                                      : 'DIF Function'
                                  }
                                  onChange={(value) => {
                                    saveDIFValue('functionCode', value);
                                  }}
                                />
                              </Grid.Column>
                            </Grid.Row>
                            <br />
                            <br />
                          </div>
                          <br />
                          <br />
                        </>
                      )}
                    </>
                  )}
              </td>
              <div
                style={{ textAlign: 'center' }}
                className={
                  state.selectedDocuments_lo.indexOf(state.selectedDocType) >= 0
                    ? 'transmitting'
                    : 'nottransmitting'
                }
              >
                <br />
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginTop: '-0.9rem',
                  }}
                >
                  <div className='imageboxthing'>
                    {(state.doclistttt||{})[selectedKxShipmentId] && (
                      <div
                        style={{ overflowY: 'scroll' }}
                        className='force-scrollbar document-picker'
                      >
                        {((state.doclistttt||{})[selectedKxShipmentId]||[])
                          .filter((a) => {
                            if (state.selectedDocType != 'use__id') {
                              return a.documentType == state.selectedDocType;
                            } else {
                              return a.docid == state.selectedDocId_p;
                            }
                          })
                          .map((doc, iiii) => {
                            let isSelectedDocType =
                              state.selectedDocuments_lo.indexOf(
                                state.selectedDocType
                              ) >= 0;
                            return (
                              <div
                                className={
                                  canSelectIndividualPages
                                    ? ' hoveranimate '
                                    : ' '
                                }
                                key={doc.docid + 'kekykey1'}
                                title={
                                  canSelectIndividualPages
                                    ? state.selectedDocuments_lo.indexOf(
                                        state.selectedDocType
                                      ) < 0
                                      ? `${
                                          (state.docTypes_zb || []).find(
                                            (a) =>
                                              a.name == state.selectedDocType
                                          )?.longLabel || 'This document'
                                        } not being sent. Click 'Transmit' to add `
                                      : dontUseTheseDocIds[doc.docid]
                                      ? "This page won't be sent. Click to send it."
                                      : 'Click to not send this page'
                                    : ''
                                }
                                style={{
                                  width: {
                                    3: '19%',
                                    2: '48%',
                                    1: '98%',
                                  }[state.zoomOutness],
                                  float: 'left',
                                  padding: '10px',
                                  backgroundColor: dontUseTheseDocIds[doc.docid]
                                    ? '#eee'
                                    : 'white',
                                }}
                                onClick={() => {
                                  if (!isSelectedDocType) return;
                                  if (!canSelectIndividualPages) return;
                                  setState({
                                    dontUseTheseDocIds: {
                                      ...dontUseTheseDocIds,
                                      [doc.docid]:
                                        !dontUseTheseDocIds[doc.docid],
                                    },
                                  });
                                }}
                              >
                                <span
                                  style={{
                                    opacity: dontUseTheseDocIds[doc.docid]
                                      ? '0.4'
                                      : '1',
                                  }}
                                >
                                  #{iiii + 1}&nbsp; &nbsp; &nbsp; &nbsp;
                                  {!isSelectedDocType ||
                                  !canSelectIndividualPages ? (
                                    <></>
                                  ) : (
                                    <>
                                      <input
                                        type='checkbox'
                                        checked={!dontUseTheseDocIds[doc.docid]}
                                      />{' '}
                                      &nbsp;
                                      <span
                                        style={{
                                          cursor: isSelectedDocType
                                            ? 'pointer'
                                            : 'auto',
                                          textDecoration: dontUseTheseDocIds[
                                            doc.docid
                                          ]
                                            ? 'line-through'
                                            : 'none',
                                        }}
                                      >
                                        Sending
                                      </span>
                                      {state.mostRecentVersions && 
                                        state.mostRecentVersions[doc.documentType] &&
                                        state.mostRecentVersions[doc.documentType] > doc.version &&
                                          <span title={`OBSOLETE! This is version ${doc.version} and the most recent version is ${state.mostRecentVersions[doc.documentType]}!`} style={{color:'gray'}}>&nbsp;[OBS]</span>}
                                    </>
                                  )}
                                </span>
                                <br />
                                <img
                                  style={{
                                    opacity: dontUseTheseDocIds[doc.docid]
                                      ? '0.4'
                                      : '1',
                                    width: '98%',
                                    cursor: isSelectedDocType
                                      ? 'pointer'
                                      : 'auto',
                                  }}
                                  src={doc.image}
                                />
                              </div>
                            );
                          })}
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-around',
                      width: 'inherit',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ marginTop: '25px' }}>
                      <Icon
                        name='zoom in'
                        disabled={state.zoomOutness <= 1}
                        style={{
                          cursor: state.zoomOutness <= 1 ? '' : 'pointer',
                        }}
                        color='black'
                        onClick={() => {
                          setState({ zoomOutness: state.zoomOutness - 1 });
                        }}
                      />{' '}
                      &nbsp;
                      <Icon
                        name='zoom out'
                        disabled={state.zoomOutness >= 3}
                        style={{
                          cursor: state.zoomOutness >= 3 ? '' : 'pointer',
                        }}
                        color='black'
                        onClick={() => {
                          setState({ zoomOutness: state.zoomOutness + 1 });
                        }}
                      />
                    </div>
                    <div style={{ float: 'right' }}>
                      <table style={{ width: '100%' }}>
                        <tbody>
                          <tr>
                            <td style={{ textAlign: 'left' }}>
                              &nbsp;&nbsp;
                              <b>
                                {
                                  (state.docTypes_zb || []).find(
                                    (a) => a.name == state.selectedDocType
                                  )?.longLabel
                                }
                              </b>
                            </td>
                            {/* <td>
                       
                      </td> */}
                          </tr>
                        </tbody>
                      </table>
                      {state.selectedDocType ? (
                        <td style={{ textAlign: 'right' }}>
                          {state.selectedDocuments_lo.indexOf(
                            state.selectedDocType
                          ) >= 0 ? (
                            <>
                              {canSelectIndividualPages && (
                                <input
                                  type='button'
                                  onChange={() => {}}
                                  checked={
                                    hasTheseDocsForThisType(
                                      state.selectedDocType,
                                      false
                                    )?.length
                                  }
                                  className='cancel-button'
                                  onClick={() => {
                                    let docsTogglingObject = {};
                                    for (let oneDoc of hasTheseDocsForThisType(
                                      state.selectedDocType,
                                      true
                                    ) || []) {
                                      docsTogglingObject[oneDoc.docid] = false; //!!hasTheseDocsForThisType(state.selectedDocType, false)?.length;
                                    }

                                    setState({
                                      dontUseTheseDocIds: {
                                        ...dontUseTheseDocIds,
                                        ...docsTogglingObject,
                                      },
                                    });
                                  }}
                                  value='Attach all'
                                />
                              )}
                              {canSelectIndividualPages && (
                                <input
                                  type='button'
                                  className='cancel-button'
                                  onChange={() => {}}
                                  checked={
                                    hasTheseDocsForThisType(
                                      state.selectedDocType,
                                      false
                                    )?.length
                                  }
                                  onClick={() => {
                                    let docsTogglingObject = {};
                                    for (let oneDoc of hasTheseDocsForThisType(
                                      state.selectedDocType,
                                      true
                                    ) || []) {
                                      docsTogglingObject[oneDoc.docid] = true; //!!hasTheseDocsForThisType(state.selectedDocType, false)?.length;
                                    }

                                    setState({
                                      dontUseTheseDocIds: {
                                        ...dontUseTheseDocIds,
                                        ...docsTogglingObject,
                                      },
                                    });
                                  }}
                                  value='Attach none'
                                />
                              )}
                            </>
                          ) : (
                            <>Not being transmitted</>
                          )}
                          {canSelectIndividualPages && (
                            <>
                              &nbsp; &nbsp;
                              {toggleThisDocType(
                                state.selectedDocType,
                                'Transmit'
                              )}
                            </>
                          )}
                        </td>
                      ) : (
                        <td>No doc</td>
                      )}
                    </div>
                  </div>
                </div>

                <DifWarnings
                  isChildShipment={false}
                  activeTabIndex={2}
                  selectedDocType={state.selectedDocType}
                  data={state.disvars}
                  allSelectedDocs={state.selectedDocuments_lo}
                  allDocs={Object.keys(numberofpagesbydoctype)}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  position: 'fixed',
                  bottom: 0,
                  marginBottom: '1rem',
                  marginLeft: '6rem',
                }}
              >
                <div
                  className='cancel-button'
                  onClick={() => props.closefunc()}
                >
                  {state.currentpage == 'final' ? 'Close' : 'Cancel'}
                </div>
                {state.currentpage == 'initial' && (
                  <>
                    {(() => {
                      let addingaNewDoc = !!state.doclist_lg.filter(
                        (a) => !a.isDone
                      ).length;
                      let disabledtext = addingaNewDoc
                        ? 'Finish adding new documents'
                        : !state.userRequestId_m
                        ? 'User request id missing.'
                        : state.creatingpdf
                        ? 'Creating PDF, please wait...'
                        : state.isChoosingaNewDoctype
                        ? 'Finish Selecting Document Type'
                        : !nameofdoc
                        ? 'Select a Document Type'
                        : false;
                      if (shipmentCountry == 'CA') {
                        let disablethis =
                          state.submittingdis ||
                          state.selectedDocuments_lo.length == 0;
                        let needtofillforms = '';
                        for (let useddoc of state.selectedDocuments_lo) {
                          if (
                            state.listOfSelectedDocuments.indexOf(useddoc) < 0
                          ) {
                            disablethis = true;
                            if (needtofillforms) {
                              needtofillforms += ' AND ';
                            }
                            needtofillforms += useddoc.toLowerCase() + ' ';
                          }
                        }
                        return (
                          <div
                            className={
                              'cancel-button blue ' +
                              (disablethis ? ' disabled ' : '')
                            }
                            disabled={disablethis}
                            onClick={() => {
                              if (disablethis) return;
                              submit_difff();
                            }}
                          >
                            {state.submittingdis
                              ? 'Submitting...'
                              : needtofillforms
                              ? `Check forms for ${needtofillforms}`
                              : 'Submit DIF request for ' +
                                state.selectedDocuments_lo.length +
                                ' document(s)'}
                          </div>
                        );
                      } else
                        return (
                          <div
                            disabled={disabledtext.length}
                            className={
                              'cancel-button blue ' +
                              (disabledtext.length ? ' disabled ' : '')
                            }
                            onClick={() => {
                              if (disabledtext.length) return;

                              setState({ showPDF: false });
                              create_pdff();
                            }}
                          >
                            {disabledtext
                              ? disabledtext
                              : `
                    Preview ${
                      state.docCodeName && state.docCodeName.length > 3
                        ? state.docCodeName
                        : ''
                    } PDF \
                    (${hasTheseDocsForThisType(null, false)?.length} Page${
                                  hasTheseDocsForThisType(null, false)
                                    ?.length == 1
                                    ? ''
                                    : 's'
                                }) \
                    `}
                          </div>
                        );
                    })()}
                  </>
                )}
              </div>
            </tr>
          </tbody>
        </table>
      </>)}
      {/* END INITIAL */}
      {/* Start creating PDF*/}
      {state.creatingpdf && (
        <div
          style={{
            height: '50vh',
            padding: '60px',
            fontSize: '2rem',
            position: 'relative',
          }}
        >
          <Dimmer active inverted className='bigDimmerContent'>
            <Loader
              inverted
              content={
                'Generating PDF' + state.pdfgenmessage + ', please wait...'
              }
            />
          </Dimmer>
        </div>
      )}
      {/* end creating pdf*/}
      {/* START PDFPAGE*/}
      {state.currentpage == 'pdfpage' && (
        <>
          <table style={{ maxHeight: '50vh' }}>
            <tr>
              <td>
                {!state.showPDF && (
                  <>
                    <h1>Loading PDF, takes a moment</h1>
                    <br />
                    <br />
                    <div className='loadingBarContainer'>
                      <div id='loadingBarPDF'></div>
                    </div>
                  </>
                )}
                <iframe
                  type='application/pdf'
                  src={state.showPDF && state.pdfurl}
                  style={{
                    width: '100%',
                    height: state.showPDF ? '50vh' : '30vh',
                  }}
                ></iframe>
              </td>
              <td style={{ width: '15vw' }}>
                <div
                  style={{
                    height: '50vh',
                    overflowY: 'scroll',
                    width: '15vw',
                  }}
                >
                  {state.doculistAsObjects.map((docci) => {
                    return (
                      <React.Fragment key={docci.docid + 'fwejfjweaaaaa'}>
                        <img src={docci.image} style={{ width: '10vw' }} />
                        <br />
                      </React.Fragment>
                    );
                  })}
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <br /> <br />
                <b>
                  DIS Comment:
                  {state.brokerComment || 'None'}
                </b>
                <br /> <br />
              </td>
            </tr>
          </table>
        </>
      )}
      {/* END PDFPAGE*/}
      {/* START FINAL*/}
      {state.currentpage == 'final' && (
        <>
          <div style={{ height: '60vh', padding: '40px' }}>
            <h1>
              {
                // shipmentCountry == 'CA' ? (
                //   <>
                //     <Icon name='check circle' color='green' />
                //     Documents submitted to DIF!!
                //   </>
                // ) :
                <>
                  {requestSuccess ? (
                    <>
                      <Icon name='check circle' color='green' />
                      {state.disdonestate}:PDF submitted to the{' '}
                      {shipmentCountry === 'US' ? `DIS!` : `DIF!`}
                    </>
                  ) : (
                    <>
                      <Icon name='exclamation' color='red' />
                      {state.disdonestate}: Submission to{' '}
                      {shipmentCountry === 'US' ? `DIS!` : `DIF!`} may have had
                      an issue:{' '}
                      {shipmentCountry === 'CA'
                        ? `Check the file size (must not be more than 4MB)`
                        : ``}
                    </>
                  )}
                </>
              }
            </h1>
            <br />
            {/* <div>
              {
                state.disdonemessage.map((item)=>{
                    item return (<div></div>)
                })
              }
            </div> */}
            <h2>Message: {state.disdonemessage}</h2>
            <br />
            <div className='cancel-button' onClick={() => props.closefunc()}>
              {state.currentpage == 'final' ? 'Close' : 'Cancel'}
            </div>
          </div>
        </>
      )}
      {/* END FINAL*/}
      <div style={{ bottom: '8px' }}>
        <div style={{ display: 'flex' }}>
          {(state.currentpage == 'pdfpage' || state.creatingpdf) &&
            shipmentCountry == 'US' && (
              <div
                className='cancel-button'
                onClick={() =>
                  setState({
                    currentpage: 'initial',
                    creatingpdf: false,
                    creatingpdfstarttime: Date.now(),
                  })
                }
              >
                Back
              </div>
            )}

          {state.currentpage == 'pdfpage' && (
            <>
              {shipmentCountry == 'US' && (
                <div
                  className={
                    'cancel-button blue ' +
                    (state.submittingdis || !state.showPDF ? ' disabled ' : '')
                  }
                  onClick={() => {
                    if (state.submittingdis || !state.showPDF) return;
                    submit_dis_requesttt();
                  }}
                >
                  {state.submittingdis
                    ? 'Submitting...'
                    : !state.showPDF
                    ? 'Wait for the PDF to load...'
                    : 'Submit PDF to DIS'}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};
